export function ajax(method, url, data, headers = {}, scope, callback) {
  const xhr = new XMLHttpRequest();

  xhr.addEventListener("readystatechange", () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      callback.call(scope, xhr);
    }
  });

  xhr.open(method, url);

  for (let key in headers) {
    xhr.setRequestHeader(key, headers[key]);
  }

  xhr.send(data);
}
